import { JSX } from 'react';
import { useIsUserAuthorised } from '@/hooks/useIsUserAuthorised';
import { Scope } from '@/types/Auth/Scope.types';
import { ErrorPage } from '../Error/ErrorPage';
import PatientDashboard from './PatientDashboard';

interface IProps {
  scope: Scope;
}

export default function PatientDashboardPage({ scope }: IProps): JSX.Element {
  const canRead = useIsUserAuthorised(scope);

  return canRead ? (
    <PatientDashboard />
  ) : (
    <ErrorPage
      message="You are not authorised to view this page"
      returnTo="dashboard"
    />
  );
}
